<template>
  <span>
    <button @click="$emit('toggleOn')" type="button" class="w3-button w3-text-theme"><i class="fas fa-plus-circle"></i> Add</button> 
  </span>
</template>

<script>
  import AddButton from './AddButton.ts'
  export default AddButton
</script>
